module.exports = "/static/assets/19b5f6627a8e68005c44273cf1702ed5.png";